import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import AOS from 'aos';
import 'aos/dist/aos.css'; // 引入AOS的CSS文件

AOS.init(); // 全局初始化AOS

import "@/style/style.css"

router.afterEach(() => {
  window.scrollTo(0, 0);
})

Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
